import { useEffect, useState } from "react";

const useFetchAuth = (url, token) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const res = await fetch(url, {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the headers
          },
        });

        if (!res.ok) {
          throw new Error("Request failed with status " + res.status);
        }

        const json = await res.json();

        setData(json);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    if (token) {
      // Ensure the token is available before making the request
      fetchData();
    }
  }, [url, token]);

  return { loading, error, data };
};

export default useFetchAuth;
